
<div  class="articles-container row"> 
  <div *ngIf="selectedArticle" class="articles-right-content col-12">
        <h1>
          {{ selectedArticle.title}}
        </h1>
        <div class="article-history align-h  margin-top-20 margin-bottom-20">
          <div class="article-history-updated stretch">{{selectedArticle.month }}, {{selectedArticle.year }}</div>
    
          <div class="article-history-sharing">
            <a href="https://twitter.com/share?url={{ pageUrl }}" target="_blank">
              <img src="assets/images/twitter-logo-blue.png" alt="twitter" />
            </a>
            <a
              href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
              target="_blank"
            >
              <img src="assets/images/facebook-icon.png" alt="facebook" />
            </a>
            
            <a
              href="https://www.linkedin.com/shareArticle?url={{ pageUrl }}"
              target="_blank"
            >
              <img src="assets/images/linkedin.png" alt="linkedin" />
            </a>
          </div>
        <span *ngIf="selectedArticle['pdfUrl'] && !inProgress" class="article-history-pdf-download--mobile" (click)="downloadAsPDF(selectedArticle['pdfUrl'])">
          <img src="assets/svg/pdf-file.svg" alt="pdf" />
        </span>
        <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
        </div>
        <div
          class="article-image"
          *ngIf="selectedArticle['imagePath']"
        >
          <img
            [src]="selectedArticle['imagePath']"
            [alt]="selectedArticle['title']"
          />
        </div>
        <div
          class="article-image"
          *ngIf="selectedArticle['video']"
        >
          <iframe class="article-vedio-iframe" [src]="getSafeUrl(selectedArticle['video'])" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
          </iframe>
        </div>
        <div class="article-html-content margin-top-35 margin-bottom-35">
          <p [innerHTML]="selectedArticle['htmlContent']"></p>
          <a *ngIf="selectedArticle['pdfUrl']" [href]="selectedArticle['pdfUrl']" target="_blank">View</a>
        </div>
          <div class="button-black">
          <button type="button" class="btn btn-primary btn-lg" (click)="investOnline()">Invest Now</button>
        </div>
  </div>
</div>




